import { mapGetters, mapActions } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
import mvtMarketTrendsCTA from '@/common/components/mvtmarkettrendscta/mvt-markettrendscta.vue';
import dppCtaCard from '@/dpp/components/dppctacard/dpp-ctacard.vue';

import format from '@/common/utilities/format';
import propertyFuncs from '@/common/utilities/propertyFuncs';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default {
    name: 'propertyMarket',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtChart,
        mvtMarketTrendsCTA,
        dppCtaCard,
    },
    props: {
        fields: {
            type: Array,
            default: [],
        },
        disableCollapse: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
        isMarket5YLoaded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filterBy: 'price',
            years: 5,
            sourceTypes: [
                {
                    text: this.molang('dpp.propertyMarket.price'),
                    value: 'price',
                },
                {
                    text: '$/Sqft',
                    value: '$/sqft',
                },
                {
                    text: this.molang('dpp.propertyMarket.inventory'),
                    value: 'inventory',
                },
                {
                    text: this.molang('dpp.propertyMarket.days'),
                    value: 'dom',
                },
            ],
            useCountyData: false,
        };
    },
    methods: {
        ...mapActions('dpp', ['fetchMarketChartData']),
        changeFilterBy(value) {
            this.filterBy = value;
        },
        toggleData(value) {
            this.years = value;
            if (this.years === 5) {
                if (!this.isMarket5YLoaded && !this.getMarket5Y) {
                    this.fetchMarketChartData({
                        cityId: this.dpp.geo.cityId,
                        countyId: this.dpp.geo.countyId,
                        neighborhoodId: this.dpp.geo.neighborhoodId,
                        zipcode: this.dpp.geo.zipcode,
                        isFiveYear: true,
                    });
                }
            } else {
                if (!this.getMarket1Y) {
                    this.fetchMarketChartData({
                        cityId: this.dpp.geo.cityId,
                        countyId: this.dpp.geo.countyId,
                        neighborhoodId: this.dpp.geo.neighborhoodId,
                        zipcode: this.dpp.geo.zipcode,
                    });
                }
            }
        },
        formatRate(rate) {
            if (!rate || rate.indexOf('-') > -1 || rate.indexOf('+') > -1 || rate == '0%') return rate;
            else if (rate.indexOf('%') > -1) return `+${rate}`;
        },
    },
    mounted() {
        this.toggleData(this.years);
        this.$eventBus.$on('proeprty-market-change', this.changeFilterBy);
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getMarket1Y', 'getMarket5Y']),
        ...mapGetters('dpp', ['dpp', 'getNearbyHome']),

        chartData() {
            var data = this.years === 1 ? this.getMarket1Y : this.getMarket5Y;
            if (data && data.dailyCityStatisticsList) {
                var filterBy = this.filterBy;
                var maxItem = data.dailyCityStatisticsList;
                if (maxItem.length < data.dailyNeighborhoodStatisticsList.length) {
                    maxItem = data.dailyNeighborhoodStatisticsList;
                }
                if (maxItem.length < data.dailyZipcodeStatisticsList) {
                    maxItem = data.dailyNeighborhoodStatisticsList;
                }
                let xAxisLabels = [];
                var labels = [];
                maxItem = maxItem.reduce((filtered, item) => {
                    let yrMonArr = item.monthYear && item.monthYear.split('/');
                    if (yrMonArr.length) {
                        const year = parseInt(yrMonArr[0]);
                        const month = parseInt(yrMonArr[1]);
                        const validData = (year == 2023 && [6, 7, 8, 9, 10, 11, 12].indexOf(month) >= 0) || year >= 2024;
                        if (validData) {
                            xAxisLabels.push(`${months[parseInt(yrMonArr[1]) - 1]} ${yrMonArr[0]}`);
                            labels.push(item.monthYear);
                            filtered.push(item);
                        }
                    }
                    return filtered;
                }, []);
                var cityData = new Array(maxItem.length),
                    neighborhoodData = new Array(maxItem.length),
                    countyData = new Array(maxItem.length),
                    zipcodeData = new Array(maxItem.length);

                for (var i = 0; i < labels.length; i++) {
                    var key = labels[i];
                    var cityItem = data.dailyCityStatisticsList.find(function (e) {
                        return e.monthYear === key;
                    });
                    var neighborhoodItem = data.dailyNeighborhoodStatisticsList.find(function (e) {
                        return e.monthYear === key;
                    });
                    var countyItem = data.dailyCountyStatisticsList.find(function (e) {
                        return e.monthYear === key;
                    });
                    var zipcodeItem = data.dailyZipcodeStatisticsList.find(function (e) {
                        return e.monthYear === key;
                    });
                    switch (filterBy) {
                        case 'price':
                            cityData[i] = cityItem ? cityItem.allTypeMedianListPrice : NaN;
                            neighborhoodData[i] = neighborhoodItem ? neighborhoodItem.allTypeMedianListPrice : NaN;
                            countyData[i] = countyItem ? countyItem.allTypeMedianListPrice : NaN;
                            zipcodeData[i] = zipcodeItem ? zipcodeItem.allTypeMedianListPrice : NaN;
                            break;
                        case '$/sqft':
                            cityData[i] = cityItem ? cityItem.allTypeMedianPricePerSqftHouse : NaN;
                            neighborhoodData[i] = neighborhoodItem ? neighborhoodItem.allTypeMedianPricePerSqftHouse : NaN;
                            countyData[i] = countyItem ? countyItem.allTypeMedianPricePerSqftHouse : NaN;
                            zipcodeData[i] = zipcodeItem ? zipcodeItem.allTypeMedianPricePerSqftHouse : NaN;
                            break;
                        case 'dom':
                            cityData[i] = cityItem ? cityItem.allTypeMedianDom : NaN;
                            neighborhoodData[i] = neighborhoodItem ? neighborhoodItem.allTypeMedianDom : NaN;
                            countyData[i] = countyItem ? countyItem.allTypeMedianDom : NaN;
                            zipcodeData[i] = zipcodeItem ? zipcodeItem.allTypeMedianDom : NaN;
                            break;
                        case 'inventory':
                            cityData[i] = cityItem ? cityItem.allTypeTotalInventory : NaN;
                            neighborhoodData[i] = neighborhoodItem ? neighborhoodItem.allTypeTotalInventory : NaN;
                            countyData[i] = countyItem ? countyItem.allTypeTotalInventory : NaN;
                            zipcodeData[i] = zipcodeItem ? zipcodeItem.allTypeTotalInventory : NaN;
                            break;
                    }
                }
                var zipcodeLabel = this.dpp.geo.zipcode;
                var cityLabel = this.dpp.geo.city;
                var neighborhoodLabel = this.dpp.geo.neighborhood;
                var countyLabel = this.dpp.geo.county;
                var currentAddressLabel = this.dpp.geo.address;
                var currentValue = new Array(maxItem.length);
                switch (filterBy) {
                    case 'price':
                        currentValue[currentValue.length - 1] = this.dpp.price;
                        break;
                    case '$/sqft':
                        currentValue[currentValue.length - 1] = this.dpp.pricePerArea;
                        break;
                    case 'dom':
                        currentValue[currentValue.length - 1] = this.dpp.daysOnMovoto;
                        break;
                    case 'inventory':
                        currentValue = null;
                        break;
                }

                const allDataPoints = [
                    ...cityData.filter(v => !isNaN(v)),
                    ...neighborhoodData.filter(v => !isNaN(v)),
                    ...countyData.filter(v => !isNaN(v)),
                    ...zipcodeData.filter(v => !isNaN(v)),
                    ...(currentValue || []).filter(v => !isNaN(v))
                ];

                const minValue = Math.min(...allDataPoints);
                const maxValue = Math.max(...allDataPoints);

                // Calculate range with 0.8 and 1.2 multipliers
                const yAxisMin = minValue * 0.8;
                const yAxisMax = maxValue * 1.2;

                const datasets = [];
                let colors = ['#CB3FE1', '#2AF1FA', '#1BB81F', '#5B43F7'];
                const isNewDpp = this.dpp.isNewDpp;
                var yAxisController = [
                    {
                        display: true,
                        position: 'right',
                        ticks: {
                            ...(isNewDpp ? { min: yAxisMin, max: yAxisMax } : { beginAtZero: true }),
                            userCallback: function (value, index, values) {
                                if (isNewDpp && (index === 0 || index === values.length - 1)) {
                                    return '';
                                }
                                // Convert the number to a string and splite the string every 3 charaters from the end
                                if (filterBy === 'price' || filterBy === '$/sqft') {
                                    return '$' + format.friendlyPrice(value);
                                } else {
                                    return value;
                                }
                            },
                        },
                        gridLines: {
                            color: 'rgba(232, 232, 232, 1)',
                        },
                    },
                ];
                // flags to determine if specific section has data or not
                const showCurrentValue = (currentValue || []).some((item) => !isNaN(item)),
                    showCityData = (cityData || []).some((item) => !isNaN(item)),
                    showNeighborhoodData = (neighborhoodData || []).some((item) => !isNaN(item)),
                    showCountyData = (countyData || []).some((item) => !isNaN(item)),
                    showZipcodeData = (zipcodeData || []).some((item) => !isNaN(item));

                this.useCountyData = !showNeighborhoodData;
                if (showCurrentValue && currentValue && currentValue.length) {
                    datasets.push({
                        label: currentAddressLabel, // Name the series
                        data: currentValue, // Specify the data values array
                        fill: false,
                        borderColor: colors[0], // Add custom color border (Line)
                        backgroundColor: colors[0], // Add custom color background (Points and Fill)
                        borderWidth: 1.5, // Specify bar border width
                        radius: 10,
                        pointHitRadius: 200,
                        ...(isNewDpp ? {lineTension: 0} : {}),
                    });
                }
                if (showNeighborhoodData && neighborhoodData && neighborhoodData.length) {
                    datasets.push({
                        label: neighborhoodLabel,
                        data: neighborhoodData,
                        fill: false,
                        borderColor: colors[1],
                        backgroundColor: colors[1],
                        pointRadius: 0,
                        pointHitRadius: 200,
                        borderWidth: 1.5,
                        ...(isNewDpp ? {lineTension: 0} : {}),
                    });
                } else if (showCountyData && countyData && countyData.length) {
                    datasets.push({
                        label: countyLabel,
                        data: countyData,
                        fill: false,
                        borderColor: colors[1],
                        backgroundColor: colors[1],
                        pointHitRadius: 200,
                        pointRadius: 0,
                        borderWidth: 1.5,
                        ...(isNewDpp ? {lineTension: 0} : {}),
                    });
                }
                if (showZipcodeData && zipcodeData && zipcodeData.length) {
                    datasets.push({
                        label: zipcodeLabel,
                        data: zipcodeData,
                        fill: false,
                        borderColor: colors[2],
                        backgroundColor: colors[2],
                        pointRadius: 0,
                        pointHitRadius: 200,
                        borderWidth: 1.5,
                        ...(isNewDpp ? {lineTension: 0} : {}),
                    });
                }
                if (showCityData && cityData && cityData.length) {
                    datasets.push({
                        label: cityLabel,
                        data: cityData,
                        fill: false,
                        borderColor: colors[3],
                        backgroundColor: colors[3],
                        pointRadius: 0,
                        pointHitRadius: 200,
                        borderWidth: 1.5,
                        ...(isNewDpp ? {lineTension: 0} : {}),
                    });
                }
                // If response doesn't have any current, zip, neighborhood and city data, then don't render chart
                if (!datasets.length) {
                    return null;
                }
                return {
                    type: 'line',
                    data: {
                        labels: xAxisLabels,
                        datasets,
                    },
                    options: {
                        interaction: {
                            intersect: false,
                            mode: 'nearest',
                        },
                        hover: {
                            animationDuration: 5,
                            mode: 'nearest',
                            intersect: false,
                        },
                        elements: {
                            point: {
                                hoverRadius: 3.5,
                            },
                        },
                        legend: {
                            display: !this.dpp.isNewDpp,
                            position: 'bottom',
                            align: 'start',
                            onClick: (e) => e.stopPropagation(),
                            labels: {
                                boxWidth: 5,
                                padding: 16,
                                usePointStyle: true,
                            },
                        },
                        responsive: true, // Instruct chart js to respond nicely.
                        maintainAspectRatio: false,
                        // Add to prevent default behaviour of full-width/height
                        scales: {
                            yAxes: yAxisController,
                            xAxes: [
                                {
                                    display: true,
                                    gridLines: {
                                        zeroLineWidth: 0,
                                        display: false,
                                    },
                                    ticks: {
                                        autoSkip: false,
                                        maxRotation: 25,
                                        minRotation: 25,
                                        callback: function (val, index, ticks) {
                                            var text = '';
                                            if (index % 12 === 0) {
                                                text = val;
                                            }
                                            return text ? text.split(' ')[1] : text;
                                        },
                                    },
                                },
                            ],
                        },
                        tooltips: {
                            enabled: true,
                            titleAlign: 'center',
                            callbacks: {
                                label: (tooltipItems, list) => {
                                    const prefix = filterBy === 'price' || filterBy === '$/sqft' ? '$' : '';
                                    const tooltipPrefix = list.datasets && list.datasets[tooltipItems.datasetIndex] ? list.datasets[tooltipItems.datasetIndex].label + ' ' : '';
                                    return `${tooltipPrefix}${prefix}${format.formatNumberByComma(tooltipItems.value)}`;
                                },
                            },
                        },
                    },
                };
            }
            return null;
        },
        compareData() {
            return propertyFuncs.compareClosestProperties(this.dpp, this.getNearbyHome, this.fields);
        },
        getTableData() {
            if (!this.dpp.marketTrendTable) {
                return null;
            }
            var defaultValue = {
                value: '—',
                class: '',
                rate: 0,
            };
            // this.useCountyData = !this.dpp.marketTrendTable.neighborhood; // if no neighborhood data
            switch (this.filterBy) {
                case 'price':
                    var key = 'allTypeMedianListPrice';
                    var rate = 'allTypeMedianListPricePercentageCompareWith1YearAgo';
                    return {
                        current: {
                            value: this.dpp.price ? '$' + format.friendlyPrice(this.dpp.price) : '—',
                        },
                        city: this.dpp.marketTrendTable.city
                            ? {
                                  value: this.dpp.marketTrendTable.city[key] ? '$' + format.friendlyPrice(this.dpp.marketTrendTable.city[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.city[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.city[rate]),
                              }
                            : defaultValue,
                        neighborhood: this.dpp.marketTrendTable.neighborhood
                            ? {
                                  value: this.dpp.marketTrendTable.neighborhood[key] ? '$' + format.friendlyPrice(this.dpp.marketTrendTable.neighborhood[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.neighborhood[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.neighborhood[rate]),
                              }
                            : defaultValue,
                        county: this.dpp.marketTrendTable.county
                            ? {
                                  value: this.dpp.marketTrendTable.county[key] ? '$' + format.friendlyPrice(this.dpp.marketTrendTable.county[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.county[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.county[rate]),
                              }
                            : defaultValue,
                        zipcode: this.dpp.marketTrendTable.zipcode
                            ? {
                                  value: this.dpp.marketTrendTable.zipcode[key] ? '$' + format.friendlyPrice(this.dpp.marketTrendTable.zipcode[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.zipcode[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.zipcode[rate]),
                              }
                            : defaultValue,
                    };
                case '$/sqft':
                    var key = 'allTypeMedianPricePerSqftHouse';
                    var rate = 'allTypeMedianPricePerSqftHousePercentageCompareWith1YearAgo';
                    return {
                        current: {
                            value: this.dpp.pricePerArea ? '$' + format.formatNumberByComma(Math.round(this.dpp.pricePerArea)) : '—',
                        },
                        city: this.dpp.marketTrendTable.city
                            ? {
                                  value: this.dpp.marketTrendTable.city[key] ? '$' + format.formatNumberByComma(this.dpp.marketTrendTable.city[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.city[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.city[rate]),
                              }
                            : defaultValue,
                        neighborhood: this.dpp.marketTrendTable.neighborhood
                            ? {
                                  value: this.dpp.marketTrendTable.neighborhood[key] ? '$' + format.formatNumberByComma(this.dpp.marketTrendTable.neighborhood[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.neighborhood[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.neighborhood[rate]),
                              }
                            : defaultValue,
                        county: this.dpp.marketTrendTable.county
                            ? {
                                  value: this.dpp.marketTrendTable.county[key] ? '$' + format.formatNumberByComma(this.dpp.marketTrendTable.county[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.county[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.county[rate]),
                              }
                            : defaultValue,
                        zipcode: this.dpp.marketTrendTable.zipcode
                            ? {
                                  value: this.dpp.marketTrendTable.zipcode[key] ? '$' + format.formatNumberByComma(this.dpp.marketTrendTable.zipcode[key]) : '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.zipcode[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.zipcode[rate]),
                              }
                            : defaultValue,
                    };
                case 'dom':
                    var key = 'allTypeMedianDom';
                    var rate = 'allTypeMedianDomPercentageCompareWith1YearAgo';
                    return {
                        current: {
                            value: this.dpp.daysOnMovoto,
                        },
                        city: this.dpp.marketTrendTable.city
                            ? {
                                  value: this.dpp.marketTrendTable.city[key] || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.city[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.city[rate]),
                              }
                            : defaultValue,
                        neighborhood: this.dpp.marketTrendTable.neighborhood
                            ? {
                                  value: this.dpp.marketTrendTable.neighborhood[key] || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.neighborhood[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.neighborhood[rate]),
                              }
                            : defaultValue,
                        county: this.dpp.marketTrendTable.county
                            ? {
                                  value: this.dpp.marketTrendTable.county[key] || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.county[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.county[rate]),
                              }
                            : defaultValue,
                        zipcode: this.dpp.marketTrendTable.zipcode
                            ? {
                                  value: this.dpp.marketTrendTable.zipcode[key] || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.zipcode[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.zipcode[rate]),
                              }
                            : defaultValue,
                    };

                case 'inventory':
                    var key = 'allTypeTotalInventory';
                    var rate = 'allTypeTotalInventoryPercentageCompareWith1YearAgo';
                    return {
                        current: {
                            value: 1,
                        },
                        city: this.dpp.marketTrendTable.city
                            ? {
                                  value: format.formatNumberByComma(this.dpp.marketTrendTable.city[key]) || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.city[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.city[rate]),
                              }
                            : defaultValue,
                        neighborhood: this.dpp.marketTrendTable.neighborhood
                            ? {
                                  value: format.formatNumberByComma(this.dpp.marketTrendTable.neighborhood[key]) || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.neighborhood[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.neighborhood[rate]),
                              }
                            : defaultValue,
                        county: this.dpp.marketTrendTable.county
                            ? {
                                  value: format.formatNumberByComma(this.dpp.marketTrendTable.county[key]) || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.county[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.county[rate]),
                              }
                            : defaultValue,
                        zipcode: this.dpp.marketTrendTable.zipcode
                            ? {
                                  value: format.formatNumberByComma(this.dpp.marketTrendTable.zipcode[key]) || '—',
                                  class: /^-/.test(this.dpp.marketTrendTable.zipcode[rate]) ? 'danger' : 'safe',
                                  rate: this.formatRate(this.dpp.marketTrendTable.zipcode[rate]),
                              }
                            : defaultValue,
                    };
            }
        },
        description() {
            const tableData = this.getTableData;
            if (tableData) {
                if (tableData.neighborhood && tableData.neighborhood.rate && tableData.neighborhood.value) {
                    return `${tableData.neighborhood.value} ${this.molang('dpp.propertyMarket.medianPrice')} ${this.dpp.geo.neighborhood || this.dpp.geo.city}, ${this.formatRate(
                        tableData.neighborhood.rate
                    )} ${this.molang('dpp.propertyMarket.yoy')}`;
                } else if (tableData.zipcode && tableData.zipcode.rate && tableData.zipcode.value) {
                    return `${tableData.zipcode.value} ${this.molang('dpp.propertyMarket.medianPrice')} ${this.dpp.geo.zipcode || this.dpp.geo.city}, ${this.formatRate(
                        tableData.zipcode.rate
                    )} ${this.molang('dpp.propertyMarket.yoy')}`;
                } else if (tableData.city && tableData.city.rate && tableData.city.value) {
                    return `${tableData.city.value} ${this.molang('dpp.propertyMarket.medianPrice')} ${this.dpp.geo.city}, ${this.formatRate(tableData.city.rate)} ${this.molang(
                        'dpp.propertyMarket.yoy'
                    )}`;
                } else if (tableData.county && tableData.county.rate && tableData.county.value) {
                    return `${tableData.county.value} ${this.molang('dpp.propertyMarket.medianPrice')} ${this.dpp.geo.county || this.dpp.geo.city}, ${this.formatRate(
                        tableData.county.rate
                    )} ${this.molang('dpp.propertyMarket.yoy')}`;
                }
            }
            if (this.dpp.listPrice && this.dpp.geo && this.dpp.geo.address) {
                return `$${format.friendlyPrice(this.dpp.listPrice)} ${this.molang('dpp.propertyMarket.listPrice')} ${this.dpp.geo.address}`;
            }
            return '';
        },
    },
};
